module.exports = __webpack_public_path__ + "static/media/11.c9169261.jpg";